import { BorderedContainer } from '../../../common/BorderedContainer';
import { SectionTitle } from '../../../common/SectionTitle';
import { PdfItem } from './PdfItem';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 活動記録PDFのURL。 */
  activityRecordPdf: IncidentDetailPatient['activityRecordPdf'];
};

/** 活動記録PDFのコンポーネント。 */
export const ActivityRecordPdf = ({ activityRecordPdf }: Props) => {
  return (
    <BorderedContainer>
      <div className="inline-flex flex-col gap-[24px]">
        <SectionTitle text="活動記録PDF" />
        <div className="inline-flex flex-col gap-[8px]">
          {activityRecordPdf.length > 0 &&
            activityRecordPdf.map(pdf => (
              <PdfItem key={pdf.documentId} pdf={pdf} />
            ))}
        </div>
      </div>
    </BorderedContainer>
  );
};
